import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';

import {getUserDevice}  from '../../../../Shared/Util';
import StoreName        from '../../../../State/Shared/Constants/StoreName';
import Playback         from '../../../../State/Stores/Playback/Playback';
import {PLAYER_SPINNER} from '../../../Shared/Constants/TestIds';
import composeTokenList from '../../Util/composeTokenList';
import renderTestId     from '../../Util/renderTestId';

import * as styles from './spinner.css';

@connect(StoreName.PLAYBACK)
class Spinner extends React.Component<IConnectProps<Playback>> {
    public shouldComponentUpdate(nextProps: IConnectProps<Playback>): boolean {
        return nextProps.value.playbackStatus !== this.props.value.playbackStatus;
    }

    public render(): JSX.Element {
        const {value} = this.props;
        const userDevice = getUserDevice(navigator.userAgent);

        // NB: Safari seems to struggle with rendering `linearGradient` strokes
        // (when integrated with catalogue)

        const leftSemiCircleClassname = composeTokenList([
            styles.leftSemiCircle,
            [!userDevice.isSafari, styles.leftSemiCircleGradient],
            [userDevice.isSafari, styles.leftSemiCircleSolid]
        ]);

        const rightSemiCircleClassname = composeTokenList([
            styles.rightSemiCircle,
            [!userDevice.isSafari, styles.rightSemiCircleGradient],
            [userDevice.isSafari, styles.rightSemiCircleSolid]
        ]);

        if (!value.isBuffering && !value.isLoading) return null;

        return (
            <div className={styles.spinner} data-test-id={renderTestId(PLAYER_SPINNER)}>
                <svg className={styles.svg} viewBox="0 0 100 100">
                    <defs>
                        <linearGradient id="spinner-gradient-left" x1="0" x2="0" y1="0" y2="1">
                            <stop offset="0" stopColor="white" stopOpacity="0.5"/>
                            <stop offset="100%" stopColor="white" stopOpacity="0"/>
                        </linearGradient>
                        <linearGradient id="spinner-gradient-right" x1="0" x2="0" y1="0" y2="1">
                            <stop offset="0" stopColor="white" stopOpacity="0.5"/>
                            <stop offset="100%" stopColor="white" stopOpacity="1"/>
                        </linearGradient>
                    </defs>
                    <path
                        className={leftSemiCircleClassname}
                        d="M50,83.276c-18.378,0-33.276-14.898-33.276-33.276
                        S31.622,16.724,50,16.724"
                    />
                    <path
                        className={rightSemiCircleClassname}
                        d="M50,83.276c18.378,0,33.276-14.898,33.276-33.276
                        S68.378,16.724,50,16.724"
                    />
                </svg>
            </div>
        );
    }
}

export default Spinner;